export enum HeroVariants {
  Blog = 'Blog',
  FullBleed = 'Full Bleed',
  Base = 'Base',
  Pillar = 'Pillar',
  BaseWithBlog = 'Base with Blog',
  Careers = 'Careers',
}

export enum HeroTextSize {
  Default = 'Default',
  Large = 'Large',
}
